module.exports = __webpack_public_path__ + "gf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/gf.svg
// module id = 817
// module chunks = 0